import { Nav, Tab } from "react-bootstrap";
import { IRequestForInformation } from "../../../api/RequestForInformation";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  requestForInformation: IRequestForInformation;
}

interface RequestForInformationProps {
  requestForInformation: IRequestForInformation;
}

const SubTabs = ({
  className,
  activeKey,
  requestForInformation,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid regardingObjectId={requestForInformation.rfiid} />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  requestForInformation,
}: RequestForInformationProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      requestForInformation={requestForInformation}
    />
  );

  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
